export const bonusCommissionEntryEndpoints = (builder) => ({
  // ✅ Create
  createBonusCommissionEntry: builder.mutation({
    query: (body) => ({
      url: "/bonus-commission-entry",
      method: "POST",
      body,
      credentials: "include",
    }),
    invalidatesTags: ["BonusCommissionEntry"],
  }),

  // ✅ List (if you want later)
  getBonusCommissionEntryList: builder.query({
    query: (params) => ({
      url: "/bonus-commission-entry",
      method: "GET",
      params,
      credentials: "include",
    }),
    providesTags: ["BonusCommissionEntry"],
  }),

  // ✅ Get By Id (optional)
  getBonusCommissionEntryById: builder.query({
    query: (id) => ({
      url: `/bonus-commission-entry/${id}`,
      method: "GET",
      credentials: "include",
    }),
    providesTags: ["BonusCommissionEntry"],
  }),

  // ✅ Update (optional)
  updateBonusCommissionEntry: builder.mutation({
    query: ({ id, body }) => ({
      url: `/bonus-commission-entry/update/${id}`,
      method: "PUT",
      body,
      credentials: "include",
    }),
    invalidatesTags: ["BonusCommissionEntry"],
  }),

  // ✅ Delete (optional)
  deleteBonusCommissionEntry: builder.mutation({
    query: (id) => ({
      url: `/bonus-commission-entry/${id}`,
      method: "DELETE",
      credentials: "include",
    }),
    invalidatesTags: ["BonusCommissionEntry"],
  }),

  // ✅ Bulk Delete (optional)
  bulkDeleteBonusCommissionEntry: builder.mutation({
    query: (ids) => ({
      url: `/bonus-commission-entry/bulk-delete`,
      method: "POST",
      body: { ids },
      credentials: "include",
    }),
    invalidatesTags: ["BonusCommissionEntry"],
  }),
});
